<template>
    <b-container fluid :class="displayNavigation ? 'display-navigation' : 'hide-navigation'">
        <navigation v-if="displayNavigation"></navigation>
        <bottom-navigation v-else-if="showBottomNavigation"></bottom-navigation>
        <disconnected v-if="connectionStatus == 'disconnected'" :auto-reload="true"></disconnected>
        <router-view v-else></router-view>
        <bottom-navigation v-if="showBottomNavigation && displayNavigation"></bottom-navigation>
        <message></message>
    </b-container>
</template>

<script>
import Navigation from './partials/Navigation';
import Message from './partials/Message';
import BottomNavigation from './partials/BottomNavigation';
import Disconnected from './pages/Disconnected';
import { mapState, mapMutations } from 'vuex';
import Axios from 'axios';

export default {
    components: { Navigation, Disconnected, BottomNavigation, Message },
    computed: {
        ...mapState(['connectionStatus', 'isLogged', 'displayNavigation']),

        showBottomNavigation() {
            return this.$route.name !== 'lottery'
        }
    },

    methods: {
      ...mapMutations(['setMessage']),
    },

    created: function () {
      if (Config.player_text) {
        this.setMessage({
          text: Config.player_text,
          callback: () => {
            if (Config.player_action === 'reload') {
              location.reload();
            }
          },
        });
      }
    }
}
</script>
